import instance from "../utils/network";

export interface RankingResponse {
  rankings: RankingDto[];
  myRank: RankingDto | null;
  total: number;
}

export interface RankingDto {
  nickname: string;
  rank: number;
  tier: string;
  points: number;
  memberId: number;
  userId: number;
  id: number;
  pubId: number;
  seasonNumber: number;
  pubName: string;
  profile?: string;
}

export interface RankingInfoResponse {
  id: number;
  memberRankingId: number;
  itmRate: number;
  itm: number;
  trophy: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export interface RakingTierCountResponse {
  list: RankingTierCountDto[];
  total: number;
}

export interface RankingTierCountDto {
  count: number;
  tier: string;
}

export function getRunnerWeekRanking(
  limit: number,
  page: number,
  year: number,
  week: number
): Promise<RankingResponse> {
  return instance.get(
    `/nest/runner-ranking?limit=${limit}&page=${page}&year=${year}&week=${week}`
  );
}

export function getRunnerMonthRanking(
  limit: number,
  page: number,
  year: number,
  month: number
): Promise<RankingResponse> {
  return instance.get(
    `/nest/runner-ranking?limit=${limit}&page=${page}&year=${year}&month=${month}`
  );
}
export function getRunnerRanking(
  season: number,
  limit: number,
  page: number
): Promise<RankingResponse> {
  return instance.get(
    `/nest/runner-ranking?season=${season}&limit=${limit}&page=${page}`
  );
}

export function getRunnerWeekRankingInfo(
  id: number
): Promise<RankingInfoResponse> {
  return instance.get(`/nest/runner-ranking/week-info/${id}`);
}

export function getRunnerMonthRankingInfo(
  id: number
): Promise<RankingInfoResponse> {
  return instance.get(`/nest/runner-ranking/month-info/${id}`);
}

export function getRunnerRankingInfo(id: number): Promise<RankingInfoResponse> {
  return instance.get(`/nest/runner-ranking/info/${id}`);
}

export function getRankingTierCount(
  season: number
): Promise<RakingTierCountResponse> {
  return instance.get(`/nest/runner-ranking/tier/${season}`);
}
